



















import { Meta } from '@/store/meta'
import axios from 'axios'
import {Vue, Component} from 'vue-property-decorator'
import { Route } from 'vue-router'
import { getModule } from 'vuex-module-decorators'

interface AuthorizeResponse {
  access_token: string;
  refresh_token: string;
}

@Component
export default class CallbackView extends Vue {

  hasLoginError = false
  errorReason = ""

  get meta() {
    return getModule(Meta)
  }

  async mounted() {
    const code = this.$route.query["code"]

    if (!code) {
      const error = this.$route.query["error"]
      const description = this.$route.query["error_description"]

      this.hasLoginError = true
      this.errorReason = description.toString()
    } else {
      const response = await this.doAuthorize(code.toString())

      this.meta.updateAccessToken(response.access_token)
      this.meta.updateRefreshToken(response.refresh_token)

      // move to dashboard
      this.$router.push("/")
    }
  }

  async doAuthorize(code: string) {
    const response = await axios.get(`${process.env.VUE_APP_API_URL}/oauth/authorize?code=${code}&redirect_uri=${process.env.VUE_APP_CALLBACK_URL}`)
    return response.data as AuthorizeResponse
  }
}

